export const DEVICE_NEW = 'new';
export const DEVICE_IN_USE = 'use';

export const translateStatus = status => {
  switch (status) {
    default:
    case DEVICE_NEW:
      return 'new devices';
    case DEVICE_IN_USE:
      return 'devices in use';
  }
};



// WEBPACK FOOTER //
// ./src/constants/deviceConstants.js